import { Input, Segmented, Select, Table, Tag } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import {
	countExpenseForm,
	loadAllExpenseForm,
	loadExpenseFormByStatus,
} from "../../redux/rtk/features/expense/expenseSlice";
import { getAllExpenseProject } from "../../redux/rtk/features/expenseProject/expenseProjectSlice";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { GreenLinkBtn } from "../UI/AllLinkBtn";
import BtnAllSvg from "../UI/Button/btnAllSvg";
import BtnViewSvg from "../UI/Button/btnViewSvg";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

function CustomTable({ list, total }) {
	const dispatch = useDispatch();
	const [status, setStatus] = useState("ACCEPTED");
	const [columnsToShow, setColumnsToShow] = useState([]);
	const projects = useSelector((state) => state.expenseProject.list);
	const [searchUser, setSearchUser] = useState("");
	const [searchProject, setSearchProject] = useState("");


	const mapProjectName = (projectId) => {
		const project = projects.find(p => p.id === projectId);
		return project ? project.name : projectId;
	};

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			title: "User Name",
			dataIndex: "user",
			key: "user",
			render: (user) => `${user?.firstName || ''} ${user?.lastName || ''}`,
		},
		{
			id: 2,
			title: "Project",
			dataIndex: "projectName",
			key: "projectName",

		},
		{
			id: 3,
			title: " Expense Title",
			key: "expenseTitle",
			dataIndex: "expenseTitle",
			// render: ({ firstName, lastName }) => firstName + " " + lastName,
		},

		{
			id: 4,
			title: "Expense Amount",
			dataIndex: "expenseAmount",
			key: "expenseAmount",
			// render: (leaveFrom) => dayjs(leaveFrom).format("DD-MM-YYYY"),
		},
		{
			id: 5,
			title: "Expense Date",
			dataIndex: "expenseDate",
			key: "expenseDate",
			render: (expDate) => dayjs(expDate).format("DD-MM-YYYY"),
		},
		// {
		// 	id: 6,
		// 	title: "Leave Duration",
		// 	dataIndex: "leaveDuration",
		// 	key: "leaveDuration",
		// 	render: (leaveDuration) => {
		// 		if (leaveDuration > 1) {
		// 			return <span>{leaveDuration} days</span>;
		// 		} else {
		// 			return <span>{leaveDuration} day</span>;
		// 		}
		// 	},
		// },
		{
			id: 7,
			title: "Status",
			dataIndex: "approvalStatus",
			key: "approvalStatus",
			render: (approvalStatus) => {
				if (approvalStatus === "APPROVED") {
					return <Tag color='green'>{approvalStatus.toUpperCase()}</Tag>;
				} else if (approvalStatus === "REJECTED") {
					return <Tag color='red'>{approvalStatus.toUpperCase()}</Tag>;
				} else if (approvalStatus === "PARTIAL APPROVED") {
					return <Tag color='orange'>{approvalStatus.toUpperCase()}</Tag>
				} else {
					return <Tag color='yellow'>{approvalStatus.toUpperCase()}</Tag>;
				}
			},
		},

		{
			id: 7,
			title: "Action",
			key: "action",
			render: ({ id }) => (
				<ViewBtn
					path={`/admin/expense/${id}`}
					text='View'
					icon={<BtnViewSvg />}
				/>
			),
		},
	];
	//make a onChange function
	const onChange = ( value) => {
		console.log( "value", value);


		setStatus(value);
		dispatch(
			loadExpenseFormByStatus({ page:1, limit:10, approvalStatus: value })
		);
	};

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	const onAllClick = () => {
		dispatch(loadAllExpenseForm());
		setStatus("all");
	};

	// const addKeys = (arr) => arr.map((i) => ({
	// 	 ...i, key: i.id,
	// 	 projectName: mapProjectName(i.projectId)
	// 	 }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1, projectName: mapProjectName(i.projectId) }));
	const filteredData = addKeys(list).filter((item) => {
		const fullName = `${item.user?.firstName || ""} ${item.user?.lastName || ""}`.toLowerCase();
		return (
			fullName.includes(searchUser.toLowerCase()) &&
			(searchProject ? item.projectName === searchProject : true)
		);
	});

	return (
		<div className='ant-card p-4 rounded mt-5'>
			<div className='flex my-2 justify-between'>
				<div className='w-50'>
					<h4 className='text-2xl mb-2'> Expense Forms</h4>
				</div>
				{list && (
					<div className='flex justify-end mr-4'>
						<div className='mt-0.5'>
							<CsvLinkBtn>
								<CSVLink
									data={list}
									className='btn btn-dark btn-sm'
									style={{ marginTop: "5px" }}
									filename='expense_forms'>
									Download CSV
								</CSVLink>
							</CsvLinkBtn>
						</div>

						<div className='ml-2 mt-0.5'>
							<GreenLinkBtn>
								<button onClick={onAllClick}>
									<BtnAllSvg size={15} title={"ALL"} />
								</button>
							</GreenLinkBtn>
						</div>

						<div>
							<Segmented
								className='text-center rounded text-red-500'
								size='middle'
								defaultValue={"APPROVED"}
								options={[
									{
										label: (
											<span>
												<i className='bi bi-person-lines-fill'></i> Accepted
											</span>
										),
										value: "APPROVED",
									},
									{
										label: (
											<span>
												<i className='bi bi-person-dash-fill'></i> Pending
											</span>
										),
										value: "PENDING",
									},
								]}
								value={status}
								onChange={onChange}
							/>
						</div>
					</div>
				)}
			</div>


			{list && (
				<div style={{ marginBottom: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>

					<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
						<Input
							placeholder="Search by User Name"
							value={searchUser}
							onChange={(e) => setSearchUser(e.target.value)}
							style={{ width: 200 }}
						/>
						<Select
							placeholder="Select Project"
							value={searchProject}
							onChange={(value) => setSearchProject(value)}
							allowClear
							style={{ width: 200 }}
						>
							{(projects || []).map((project) => (
								<Select.Option key={project.id} value={project.name}>
									{project.name}
								</Select.Option>
							))}
						</Select>
					</div>
				</div>
			)}

			<Table
				className='text-center'
				scroll={{ x: true }}
				loading={!list}
				pagination={{
					defaultPageSize: 20,
					pageSizeOptions: [10, 20, 50, 100, 200],
					showSizeChanger: true,
					total: total ? total : 100,
					onChange: (page, limit) => {
						console.log("page", page, "limit", limit, "value", status);

						dispatch(loadAllExpenseForm({ page, limit, approvalStatus:status }));
					},
				}}
				columns={columnsToShow}
				// dataSource={list ? addKeys(list) : []}
				dataSource={filteredData}
			/>
		</div>
	);
}

const GetAllExpenses = (props) => {
	const dispatch = useDispatch();
	const list = useSelector((state) => state.expense.list);
	const total = useSelector((state) => state.expense.total);

	useEffect(() => {
		dispatch(loadAllExpenseForm());
		dispatch(countExpenseForm());
		dispatch(getAllExpenseProject());
	}, []);

	// useEffect(() => {
	//   deleteHandler(list, deletedId);
	// }, [deletedId, list]);

	return (
		<UserPrivateComponent permission={"readAll-leaveApplication"}>
			<div className='card card-custom'>
				<div className='card-body'>
					<CustomTable list={list} total={total} />
				</div>
			</div>
		</UserPrivateComponent>
	);
};

export default GetAllExpenses;
